<template>
  <Modal extra-class="dea-modal--avatar dea-modal--no-footer" :visible="visible" @modal-close="$emit('modal-close')">
    <template #title>
      Modifica la tua immagine di profilo
    </template>
    <template #content>
      <div class="avatar-container">
        <img v-for="(avatar, name, index) in avatarsList" :key="index" class="avatar-image" :src="avatar" :alt="name" />
      </div>
      <Buttons
        class="dea-button--large"
        :disabled="!avatarNumber"
        @click="$emit('user-update', { avatar: avatarNumber })"
        >Salva modifiche</Buttons
      >
    </template>
  </Modal>
</template>

<script>
import $ from "jquery";

import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";
import avatars from "~/assets/avatars/avatars";
import "slick-carousel/slick/slick.min.js";

export default {
  name: "AvatarModal",
  components: { Buttons, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avatars,
      avatarNumber: null,
      selectedAvatar: "",
    };
  },
  computed: {
    avatarsList() {
      const dashIndex = this.user.role.indexOf("_");
      const role = this.user.role.substring(dashIndex + 1);
      const filtered = Object.entries(this.avatars).filter(el => el[0].includes(role.toLowerCase()));
      return Object.fromEntries(filtered);
    },
  },
  mounted() {
    const component = this;
    $(document).ready(function() {
      $(".avatar-container").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        cssEase: "linear",
        infinite: true,
        prevArrow:
          '<button class="slick-arrow slick-prev dea-button dea-button--large dea-button--circle"><span class="dea-button__icon icon dea-ico-go-to"></span></button>',
        nextArrow:
          '<button class="slick-arrow slick-next dea-button dea-button--large dea-button--circle"><span class="dea-button__icon icon dea-ico-go-to"></span></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      $(".slick-slide").click(function(event) {
        document.querySelectorAll(".avatar-image").forEach(el => {
          // eslint-disable-next-line no-param-reassign
          el.style.border = "0";
        });
        // eslint-disable-next-line no-param-reassign
        event.target.style.border = "2px solid black";
        const name = event.target.alt;
        const dashIndex = name.indexOf("_");
        component.avatarNumber = name.substring(dashIndex + 1);
      });
    });
  },
  beforeDestroy() {
    $(".avatar-container").slick("unslick");
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "./node_modules/slick-carousel/slick/slick.scss"; //sass-lint:disable-line clean-import-paths

$avatar-width: 170px;
$modal-width: 930px;
$modal-width-tablet: 550px;
$modal-width-mobile: 300px;

.dea-modal--avatar {
  @include media("<=s") {
    max-width: $modal-width-tablet;
  }

  @include media("<=xs") {
    max-width: $modal-width-mobile;
  }

  max-width: $modal-width;

  .avatar-image {
    @include media(">xs") {
      width: $avatar-width !important; //sass-lint:disable-line no-important
    }
    border: $border-light $dea-color-grey-medium-light;
    border-radius: $border-radius-medium;
    box-shadow: $box-shadow-medium;
    margin-right: $space-x-small;
    padding: $space-small;

    &--selected {
      border: $border-bold;
    }

    &:focus {
      border: 2px solid black;
    }
  }

  .slick-arrow {
    background-color: $dea-color-grey-dark;
    border-radius: $border-radius-circle;
    margin-top: 0 !important; //sass-lint:disable-line no-important
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }

  .slick-prev {
    display: none !important; //sass-lint:disable-line no-important
  }

  .slick-next {
    right: -($gutter / 2);
  }

  .dea-button {
    margin-top: $space-base;
  }
}
</style>
